import $ from 'jquery';

export function initializeNavigation() {
    const $menu = $('#mainMenu > ul');

    if (!$menu.length) {
        console.warn('Navigatie: #mainMenu > ul niet gevonden');
        return;
    }

    const mobile = window.matchMedia('(max-width: 767px)').matches;

    const $items = $menu.find('li');
    const $links = $menu.find('a.hasSubMenu');

    // Oude eventhandlers verwijderen
    $items.off('.changburiNav');
    $links.off('.changburiNav');

    if (mobile) {
        $items.removeClass('hover');

        $links.on('click.changburiNav', function (event) {
            event.preventDefault();

            const $item = $(this).closest('li');
            const wasActive = $item.hasClass('Nactive');

            $item.siblings().removeClass('Nactive');
            $item.toggleClass('Nactive', !wasActive);
        });
    } else {
        $items.removeClass('Nactive');

        $items
            .on('mouseenter.changburiNav', function () {
                const $item = $(this);
                const $submenu = $item.children('.subMenu');

                if ($submenu.length) {
                    $item.addClass('hover');
                    $submenu.stop(true, true).fadeIn(150);
                }
            })
            .on('mouseleave.changburiNav', function () {
                const $item = $(this);

                $item.removeClass('hover');
                $item.children('.subMenu')
                    .stop(true, true)
                    .fadeOut(150);
            });
    }
}

export function initializeMobileToggle() {
    $('.navbar-toggle')
        .off('click.changburiToggle')
        .on('click.changburiToggle', function () {
            $('#mainMenu').collapse('toggle');
        });
}
